import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedModalFormComponent } from '@app/components';
import { TrainingProgramRecord } from '@app/models/training/training-program-record.model';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { AuthService } from '@app/services';
import { IndexView } from '@common/views';
import { UpcomingTrainingIndexTable } from '@employees/services';
import { CompletedTrainingIndexTable } from '@employees/services/tables/training/completed-training-index.table';
import { DeleteRecordModal, TrainingRecordReminderForm } from '@forms/employees/components';
import { Employee } from '@models/employee/employee.model';
import { TrainingProgram } from '@models/training/training-program.model';

@Component({
    templateUrl: './training-index.template.html',
    styleUrls: ['./training-index.style.scss'],
})
export class TrainingIndexView extends IndexView {
    @ViewChild('deleteRecordModal') deleteRecord: DeleteRecordModal;
    @ViewChild('sendReminderForm') sendReminderForm: TrainingRecordReminderForm;
    @ViewChild('trainingRecordFormModal') trainingRecordFormModal: DeprecatedModalFormComponent;
    @ViewChild('trainingOnceOffModal') trainingOnceOffModal: DeprecatedModalFormComponent;

    permission = TrainingProgram.managePermission;

    isLoading = false;

    employee: Employee;
    upcoming: UpcomingTrainingIndexTable;
    completed: CompletedTrainingIndexTable;

    currentTrainingProgramRecord: TrainingProgramRecord;

    constructor(
        protected route: ActivatedRoute,
        protected auth: AuthService,
        protected router: Router
    ) {
        super();
        this.employee = this.route.snapshot.data.models.get('employee');
        this.upcoming = new UpcomingTrainingIndexTable(auth, route, this.employee);
        this.completed = new CompletedTrainingIndexTable(auth, route, this.employee);
    }

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;

        this.currentTrainingProgramRecord = data as TrainingProgramRecord;

        switch (menuItem.event) {
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.deleteRecord.confirm(this.currentTrainingProgramRecord);
                break;
            case 'remind':
                this.onRemind();
                break;
            case 'record':
                this.onRecord();
                break;
        }
    }

    onCancel(): void {}

    reloadTrainingRecords(): void {
        this.upcoming.reload();
        this.completed.reload();
    }

    onCreateNew(): void {
        this.trainingOnceOffModal.show();
    }

    onOnceOffModalClose(): void {
        this.trainingOnceOffModal.hide();
    }

    onOnceOffModalSave(): void {
        this.reloadTrainingRecords();
        this.trainingOnceOffModal.hide();
    }

    private onEdit(): void {
        this.setEditRecordModalHeader();
        this.trainingRecordFormModal.show();
    }

    private onRecord(): void {
        this.setCompleteRecordModalHeader();
        this.trainingRecordFormModal.show();
    }

    private onRemind(): void {
        this.sendReminderForm.open(this.currentTrainingProgramRecord);
    }

    private setEditRecordModalHeader(): void {
        this.trainingRecordFormModal.headerText = `Edit ${this.currentTrainingProgramRecord.trainingProgram.name}`;
    }

    private setCompleteRecordModalHeader(): void {
        this.trainingRecordFormModal.headerText = `Complete ${this.currentTrainingProgramRecord.trainingProgram.name}`;
    }
}
